import { Box, SectionHelper, TextButton } from '@wix/design-system';
import React from 'react';
import { useTranslation } from '@wix/app-market-core';
import { AppIncompatibleNotificationDataHooks } from './data-hooks';
import { StatusAlertSmall } from '@wix/wix-ui-icons-common';

export interface AppIncompatibleNotificationProps {
  appName: string;
  onFindSimilarAppsClick(): void;
}

export function AppIncompatibleNotification({
  appName,
  onFindSimilarAppsClick,
}: AppIncompatibleNotificationProps) {
  const { t } = useTranslation();

  return (
    <SectionHelper
      dataHook={AppIncompatibleNotificationDataHooks.container}
      appearance="danger"
      title={t('app.page.incompatible.app.notification.title', {
        appName,
        interpolation: { escapeValue: false },
      })}
      fullWidth={true}
      size="small"
      showPrefixIcon
      prefixIcon={
        <Box padding="0 2px">
          <StatusAlertSmall />
        </Box>
      }
    >
      <TextButton
        dataHook={AppIncompatibleNotificationDataHooks.findSimilarAppsLink}
        size="small"
        underline="always"
        skin="dark"
        onClick={onFindSimilarAppsClick}
      >
        {t('app.page.incompatible.app.notification.actionButtonText')}
      </TextButton>
    </SectionHelper>
  );
}
